import { createAction, props } from '@ngrx/store';
import { IFeatureAvailability } from '@shared/interfaces/feature-availability.interface';

export const loadFeatureAvailability = createAction('[Feature Availability] Load');

export const loadFeatureAvailabilitySuccess = createAction(
  '[Feature Availability] Load Success',
  props<{ features: IFeatureAvailability[] }>(),
);

export const loadFeatureAvailabilityFailure = createAction(
  '[Feature Availability] Load Failure',
  props<{ error: string }>(),
);

export const resetFeatureAvailability = createAction('[Feature Availability] Reset');
